import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, ModalController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

import { Country } from '../../models/country.model';
import { Shop } from '../../models/shop.model';
import { User } from '../../models/user.model';

import { CountryProvider } from '../../providers/country/country';
import { ShopProvider } from '../../providers/shop/shop';
import { UserProvider } from '../../providers/user/user';

import { RetailersPage } from '../retailers/retailers';

@IonicPage()
@Component({
  selector: 'page-register-user',
  templateUrl: 'register-user.html',
})
export class RegisterUserPage {

  countries: Country[];
  selectedCountry: Country;

  selectedShop: Shop;

  user: User;
  err: string;
  loading: boolean;

  constructor(public storage: Storage, public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public modalCtrl: ModalController, public countryProvider: CountryProvider, public shopProvider: ShopProvider, public userProvider: UserProvider) {
    this.user = new User({
      email: '',
      lastname: '',
      firstname: '',
      country_id: 0,
      language_id: 0,
      shop_id: 0
    });

    this.selectedShop = null;

    this.selectedCountry = null;
  }

  getCountries() {
    this.loading = true;
    this.countryProvider.getAll()
      .subscribe(
        countries => this.countries = countries,
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  openRetailersModal() {
    this.storage.get('current_brand').then((brand) => {
      let retailersModal = this.modalCtrl.create(RetailersPage, { countryID: this.selectedCountry.id, countryName: this.selectedCountry.name }, { cssClass: brand.name });
      retailersModal.present();

      retailersModal.onDidDismiss(shop => {
        if (shop) {
          this.selectedShop = shop;
          this.user.shop_id = this.selectedShop.id;
        }
      });
    });
  }

  selectCountry(country: Country) {
    this.selectedCountry = country;

    this.user.country_id = country.id;
    this.user.language_id = 0;
    this.user.shop_id = 0;

    this.selectedShop = null;
  }

  register() {
    let loading = this.loadingCtrl.create({
      content: this.translate.instant('MSG_PLEASE_WAIT')
    });

    loading.present();

    let values = {
      email: this.user.email,
      lastname: this.user.lastname,
      firstname: this.user.firstname,
      country_id: this.user.country_id,
      language_id: this.user.language_id,
      shop_id: this.user.shop_id
    };

    this.userProvider.register(values)
      .subscribe(
        user => {
          this.user = new User({
            email: '',
            lastname: '',
            firstname: '',
            country_id: 0,
            language_id: 0,
            shop_id: 0
          });

          this.selectedCountry = null;
        },
        error => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_ERROR_TITLE'),
            subTitle: this.translate.instant('MODAL_ERROR_REGISTER_USER'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        },
        () => {
          loading.dismiss();
          let alert = this.alertCtrl.create({
            title: this.translate.instant('MODAL_SUCCESS_TITLE'),
            subTitle: this.translate.instant('MODAL_SUCCESS_REGISTER_USER'),
            buttons: [
              this.translate.instant('BTN_OK')
            ]
          });
          alert.present();
        }
      );
  }

  ionViewDidLoad() {
    this.getCountries();
  }

}



// WEBPACK FOOTER //
// ./src/pages/register-user/register-user.ts